import Vue from 'vue'
import Vuex from 'vuex';


Vue.use(Vuex);

export default new Vuex.Store({
	state: {
	  token: window.sessionStorage.getItem('token') ? window.sessionStorage.getItem('token') : ''
	},
	mutations: {
	  setToken (state,token) {
		state.token =token;
		window.sessionStorage.setItem("token",token.token);     //存储token
	  },
	  delToken (state) {
		state.token = '';
		window.sessionStorage.clear("token");    //删除token
	  }
	}
  })
   



// WEBPACK FOOTER //
// ./src/store/index.js